/*
Copyright (c) 2019 - https://codepen.io/jeffsmith/pen/mPByya/

Permission is hereby granted, free of charge, to any person
obtaining a copy of this software and associated documentation
files (the "Software"), to deal in the Software without restriction,
 including without limitation the rights to use, copy, modify,
merge, publish, distribute, sublicense, and/or sell copies of
the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall
be included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES
OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT
HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER
DEALINGS IN THE SOFTWARE.

*/


(function ($) {
  var tabs = $(".js-tabs");

  var increment=0;
  $('ul.js-tabs-list a').each(function(){
      increment++;
      var newLink='#tab-'+increment;
      $(this).attr('href',newLink);
  });

  // For each individual tab DIV, set class and aria-hidden attribute, and hide it
  $(tabs).find("> div").attr({
    "class": "js-tab-panel",
    "aria-hidden": "true"
  }).hide();

  // Get the list of tab links
  var tabsList = tabs.find("ul.js-tabs-list");

  // For each item in the tabs list...
  $(tabsList).find("li > a").each(
    function(a){
      var tab = $(this);

      // Create a unique id using the tab link's href
      var tabClass = "tab-" + tab.attr("href").slice(1);

      // Assign tab id and aria-selected attribute to the tab control, but do not remove the href
      tab.attr({
        "aria-selected": "false",
      }).parent().attr("role", "presentation");

      tab.addClass(tabClass);
      // Assign aria attribute to the relevant tab panel
      $(tabs).find(".js-tab-panel").eq(a).attr("aria-labelledby", tabClass);

      // Set the click event for each tab link
      tab.click(
        function(e){
          var tabPanel;

          // Prevent default click event
          e.preventDefault();

          // Change state of previously selected tabList item
          $(this).parents('.js-tabs-list').find("a.current").removeClass("current").attr("aria-selected", "false");

          // Hide previously selected tabPanel
          $(this).parents('.js-tabs').find(".js-tab-panel:visible").attr("aria-hidden", "true").hide();

          // Show newly selected tabPanel
          tabPanel = $(this).parents('.js-tabs').find(".js-tab-panel").eq(tab.parent().index());
          tabPanel.attr("aria-hidden", "false").show();

          // Set state of newly selected tab list item
          tab.attr("aria-selected", "true").addClass("current");

          // Set focus to the first heading in the newly revealed tab content
          tabPanel.find("input").attr("tabindex", -1).focus();
        }
      );
    }
  );

  // Set keydown events on tabList item for navigating tabs
  $(tabsList).delegate("a", "keydown",
    function (e) {
      var tab = $(this);
      switch (e.which) {
        case 37: case 38:
        if (tab.parent().prev().length!=0) {
          tab.parent().prev().find("> a").click();
        } else {
          $(tabsList).find("li:last > a").click();
        }
        break;
        case 39: case 40:
        if (tab.parent().next().length!=0) {
          tab.parent().next().find("> a").click();
        } else {
          $(tabsList).find("li:first > a").click();
        }
        break;
      }
    }
  );

  function tabInit() {
    // Show the first tabPanel
    if (!$('.js-tabs').hasClass('js-tabs--closed')) {
      $(tabs).find(".js-tab-panel:first").attr("aria-hidden", "false").show();

      // Set state for the first tabsList li
      $(tabsList).find("li:first a").addClass("current").attr({
        "aria-selected": "true",
        "tabindex": "0"
      });
    }
  }

  // Execute tabInit on load
  $(window).on('load', tabInit);


})(jQuery);
